// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import useMergeProps from '../../../hooks/useMergeProps';
import { selectRuntimeLicence } from '../../../selectors/runtime/runtimePrimary.selector';
import MPSwipeCards from '../components/common/MPSwipeCards';
import { useMPFamilyContext } from '../contexts/MPFamilyContext';
import { selectMPUserFamily } from '../selectors/user';

type MPSwipeCardsContainerProps = {
  className?: string;
};

const MPSwipeCardsContainer = (ownProps: MPSwipeCardsContainerProps) => {
  const location = useLocation();
  const licence = useSelector(selectRuntimeLicence);
  const { familyId } = useMPFamilyContext();

  const selectorProps = useMemo(() => ({ familyId }), [familyId]);
  const familyProgress = useSelector((state) => selectMPUserFamily(state, selectorProps));

  const selectedProps = useMemo(
    () => ({
      licence,
      cards: familyProgress?.cards ? Object.values(familyProgress.cards) : [],
    }),
    [familyProgress, licence],
  );

  const { state: { indexToSwipe = 0 } = {} } = location;

  const otherProps = useMemo(() => ({ indexToSwipe }), [indexToSwipe]);

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return <MPSwipeCards {...enhancedProps} />;
};

export default MPSwipeCardsContainer;
